import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { PORTAL_ROLES } from "@constants/portalRoles";
import { selectPortalRole } from "@store/selectors/portalRoleSelectors";

/**
 * Chairman users may only view the dashboard. Redirect any other main-layout path to home.
 */
const ChairmanContentGuard = ({ children }: { children: ReactNode }) => {
	const role = useSelector(selectPortalRole);
	const location = useLocation();

	if (role !== PORTAL_ROLES.CHAIRMAN) {
		return <>{children}</>;
	}

	const path = location.pathname;
	const isDashboard = path === BROWSER_ROUTES.DASHBOARD || path === "/" || path === "";
	if (!isDashboard) {
		return <Navigate to={BROWSER_ROUTES.DASHBOARD} replace />;
	}

	return <>{children}</>;
};

export default ChairmanContentGuard;
